import styled from '@emotion/styled'
import { breakpoints, spacing, Text, typography } from 'main/ui'

export const TitleWrapper = styled.div`
  text-align: center;
  margin-bottom: ${spacing.majorScale(4)}px;
`

export const Title = styled(Text)`
  font-size: ${typography.fontSize.heading.small};
`

export const FormSpacer = styled.div`
  min-height: 100px;
`

export const FormWrapper = styled.div`
  background-image: url('https://ucarecdn.com/d7410b35-f23a-4143-ab6e-c2a06bfb0718/staff_accept_invite.png');
  min-height: 300px;
  background-repeat: no-repeat;
  background-position: bottom;
  @media (max-width: ${breakpoints.lg - 1}px) {
    background: none;
    min-height: auto;
  }
`
